module.exports = __webpack_public_path__ + "img/repeat.1e033ffb.svg";